// noinspection JSUnusedGlobalSymbols

import Legend from 'ol-ext/legend/Legend'
import type Layer from 'ol/layer'
import LegendImage from 'ol-ext/legend/Image'
import { Style } from 'ol/style'
import type { OpportunityVectorLayerService } from '~/services/opportunityVectorLayer.service'

export class OpportunityMapService {
    public vectorStyles: any
    public legend: Legend
    public legend2: Legend

    constructor(private map: Map) {
        this.vectorStyles = {}
    }

    setLegend(legend: Legend) {
        this.legend = legend
    }

    updateLegendVectorStyle(
        layer: Layer,
        basicVectorLayerService: OpportunityVectorLayerService,
    ) {
        if (!this.vectorStyles[name]) {
            this.vectorStyles[name] = { title, layer }
        }

        if (!this.vectorStyles[name].layerLegend) {
            this.vectorStyles[name].layerLegend = new Legend({ layer, title })
            this.vectorStyles[name].layerLegend.addItem(new LegendImage({
                title,
            }))

            this.legend.addItem(this.vectorStyles[name].layerLegend)
        }

        const layerLegend = this.vectorStyles[name].layerLegend as Legend

        for (let i = 1; i <= 5; i++) { // dirty but working
            // clear layerLegend
            layerLegend.getItems().forEach((item) => {
                layerLegend.removeItem(item)
            })
        }

        if (styleJson.style) {
            const styleOptions = basicVectorLayerService.getStyleOptionsFromJson(styleJson.style)
            layerLegend.addItem({
                title,
                typeGeom: styleJson.geometry_subtype,
                style: new Style(styleOptions),
            })
        }
    }
}
